// extracted by mini-css-extract-plugin
export default {"selectedCounter":"manualpo__SelectAll-module__selectedCounter___g3u1r","selectAllLabel":"manualpo__SelectAll-module__selectAllLabel___RWN8c"};